// UI-4: the drawer (addendum 3): from the left, min(320px, 86vw) on a phone (the full 272px on a
// tablet), full height, the SAME Sidebar inside. Closes on the backdrop, Escape and any
// navigation; holds focus while open; the page behind does not scroll; FloatingAsk hides.
import React, { useRef } from 'react';
import { Layer, useOverlay } from '../Overlay';
import './shell.css';

export default function Drawer({ open, onClose, children }) {
  const ref = useRef(null);
  useOverlay(ref, open, { onClose, keyboard: false });
  if (!open) return null;
  return (
    <Layer>
      <div className="ui-drawer__backdrop" aria-hidden="true" onClick={onClose} />
      <div ref={ref} role="dialog" aria-modal="true" aria-label="Menu" tabIndex={-1} className="ui-drawer" data-testid="drawer">
        {children}
      </div>
    </Layer>
  );
}
